import React from "react";
import TitleBox from "../common/TitleBox";
import { useNavigate } from "react-router-dom";
import { HealthInfoButton } from "./HealthInfoButton";

const FoodLifeCard = ({ userDietLife, handleToggle }) => {
  const navigate = useNavigate();
  const datas = [
    { id: 1, title: "Eating Difficulties", data: "dietInconvenient" },
    { id: 2, title: "Food Allergies", data: "allergie" },
    { id: 3, title: "Lactose Intolerance", data: "lactoseIntolerance" },
    { id: 4, title: "Tolerated Dairy Products", data: "lactoseIntoleranceEdible" },
    { id: 5, title: "Breakfast", data: "breakfastEat" },
    { id: 6, title: "Snack Frequency", data: "snackPreferCount" },
    { id: 7, title: "Meal Preparation", data: "dietPrepare" },
  ];

  const dataMore = [
    { id: 1, title: "Eating Issues", name: "dietProblem" },
    { id: 2, title: "Eating Speed", name: "dietRate" },
    { id: 3, title: "Preferred Foods", name: "dietPreferType" },
    {
      id: 4,
      title: "Daily Water Intake",
      name: "waterGlassCount",
      per1ml: "200ml X ",
    },
    { id: 5, title: "Recent Weight Change", name: "changeWeight", unit: "kg" },
    { id: 6, title: "Supplements", name: "healthFood" },
    { id: 7, title: "Smoking", name: "smoke" },
    { id: 8, title: "Alcohol Consumption", name: "alcoholNumber" },
  ];

  //const sliceAllergie = userDietLife['allergie']?.slice(0, 2)
  return (
    <div className="space-y-[28px] rounded-lg bg-yellow_10 p-6" id="food">
      <div onClick={handleToggle} className="flex flex-row justify-between">
        <div className="flex items-center gap-1 ">
          <TitleBox option={1} title={"Dietary Habits"} />
          <div className="rounded-lg bg-white px-3 py-1 text-base font-bold text-gray_140">
            Edit
          </div>
        </div>
        <img
          alt={"arrowRight"}
          src="/images/mobile/icon/arrow_right.svg"
          className="rotate-90 transform"
        />
      </div>
      <div className="space-y-3 border-b border-dashed border-yellow_160 pb-6">
        {datas.map((el) => (
          <ul key={el.id} className="flex justify-between gap-3">
            <li className="w-[140px] flex-shrink-0 text-left text-body3_700 text-gray_160">
              {el.title}
            </li>
            <li className="flex-1 text-right text-body3_700 text-yellow_180 break-words">
              {/* {userDietLife[el.data] ?
                                (el.data === 'dietInconvenient' ? ifLength6SLice(userDietLife[el.data]) :
                                    el.data === "allergie" ? userDietLife['allergie'].length === 0 ? '없음' : sliceAllergie.map((li, idx) => <span key={idx}>{li}{idx + 1 === sliceAllergie?.length ? (sliceAllergie?.length === 2 ? "..." : "") : ", "}</span>) :
                                        el.data === "lactoseIntoleranceEdible" ?
                                            userDietLife[el.data]?.map((li, idx) => <div key={idx}>{li}{idx + 1 === userDietLife[el.data]?.length ? "" : ","}</div>) :
                                            userDietLife[el.data]
                                ) : "-"} */}
              {userDietLife[el.data]
                ? el.data === "dietInconvenient"
                  ? userDietLife["dietInconvenient"].slice(0, 3)
                  : el.data === "allergie"
                  ? userDietLife["allergie"].length === 0
                    ? "None"
                    : userDietLife["allergie"].map((li, idx) => (
                        <span key={idx}>
                          {li}
                          {idx + 1 === userDietLife["allergie"].length
                            ? ""
                            : ", "}
                        </span>
                      ))
                  : el.data === "lactoseIntoleranceEdible"
                  ? userDietLife[el.data]?.map((li, idx) => (
                      <div key={idx}>
                        {li}
                        {idx + 1 === userDietLife[el.data]?.length ? "" : ", "}
                      </div>
                    ))
                  : userDietLife[el.data]
                : "-"}
            </li>
          </ul>
        ))}
        <HealthInfoButton
          onClick={() =>
            navigate("/question/food", { state: { from: "healthInfo" } })
          }
          content={"Edit"}
          textColor={"text-yellow_160"}
          boxShadow={"0px 0px 5px #DDD3A3"}
        />
      </div>
      <div className="space-y-3">
        <TitleBox option={1} title={"Additional Dietary Info"} />
        {dataMore.map((data) => (
          <ul key={data.id} className="flex justify-between gap-3">
            <li className="w-[140px] flex-shrink-0 text-left text-body3_700 text-gray_160">
              {data.title}
            </li>
            <li className="flex-1 text-right text-body3_700 text-orange_120 break-words">
              {["waterGlassCount"] && userDietLife ? data.per1ml : ""}
              {userDietLife[data.name]
                ? data.name === "dietPreferType"
                  ? userDietLife["dietPreferType"]?.map(
                      (el, idx) =>
                        el +
                        (idx + 1 === userDietLife["dietPreferType"]?.length
                          ? ""
                          : ", ")
                    )
                  : data.name === "dietProblem"
                  ? userDietLife["dietProblem"]?.map(
                      (el, idx) =>
                        el +
                        (idx + 1 === userDietLife["dietProblem"]?.length
                          ? ""
                          : ", ")
                    )
                  : userDietLife[data.name]
                : "-"}
              {userDietLife[data.name] ? data.unit : ""}
            </li>
          </ul>
        ))}
      </div>
      <HealthInfoButton
        onClick={() =>
          navigate("/question/foodadd", { state: { from: "healthInfo" } })
        }
        content={"Edit"}
        textColor={"text-yellow_160"}
        boxShadow={"0px 0px 5px #DDD3A3"}
      />
    </div>
  );
};

export default FoodLifeCard;
